// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({widgetLabel:"Legenda",points:"Punten",lines:"Lijnen",polygons:"Vlakken",creatingLegend:"Legenda maken",noLegend:"Geen legenda",dotValue:"1 punt = {value} {unit}",currentObservations:"Huidige observaties",previousObservations:"Vorige observaties",high:"Hoog",low:"Laag",esriMetersPerSecond:"m/s",esriKilometersPerHour:"km/u",esriKnots:"knopen",esriFeetPerSecond:"ft/sec",esriMilesPerHour:"mpu",showNormField:"{field} gedeeld door {normField}",showNormPct:"{field} als procent van het totaal",showRatio:"Verhouding van {field} tot {normField}",showRatioPercent:"{field} als een procent van {normField}",showRatioPercentTotal:"{field} als een procent van {field} en {normField}",band0:"band_0",band1:"band_1",band2:"band_2",red:"Rood",green:"Groen",blue:"Blauw"});